import { IRecommendedShiftsReducer } from 'models/Shift'
import { Action } from 'redux'
import { isType } from 'ts-action'
import {
  GetUpshifterRecommendedShifts,
  UpshifterRecommendedShiftsFetching,
  ClearUpshifterRecommendedShiftsReducer,
  UpshifterRecommendedShiftsSetHasMore,
  GetUpshifterRecommendedShiftsWithoutConcat,
} from './actions'

const initialState: IRecommendedShiftsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const upshifterRecommendedShiftsReducer = (
  state = initialState,
  action: Action,
): IRecommendedShiftsReducer => {
  if (isType(action, GetUpshifterRecommendedShifts)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: [...state.data, ...data],
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, GetUpshifterRecommendedShiftsWithoutConcat)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: data,
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, UpshifterRecommendedShiftsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, UpshifterRecommendedShiftsSetHasMore)) {
    const { payload } = action
    return {
      ...state,
      hasMore: payload,
    }
  }
  if (isType(action, ClearUpshifterRecommendedShiftsReducer)) {
    return initialState
  }
  return state
}
